import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const IncentivesSkeleton = () => {
  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end"></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            
            {/* Heading */}
            <div style={{ textAlign: "center", fontWeight: "bold" ,margin:"2px"}}>
              <Skeleton
                height={28}
                width={250}
                style={{ marginBottom: '15px', textAlign: "center", alignItems: "center" }}
              />
            </div>

            {/* Subheading */}
            <div className="row incentives-subheading justify-content-between">
              <Skeleton width={120} height={20} />
              <Skeleton width={200} height={20} />
            </div>

            <div className="table-container">
              <table style={{ width: "100%" }}>
                <tbody>
                  
                  {/* 4kcActive Row */}
                  <tr>
                    <td>
                      <Skeleton height={24} width={100} style={{ marginBottom: '10px' }} />
                      <Skeleton height={20} width={180} />
                    </td>
                    <td colSpan={4}>
                      <div style={{ display: "flex", gap: "30px", justifyContent: "space-around" }}>
                        {[...Array(12)].map((_, key) => (
                          <div key={key} className="forver_month" style={{ 
                            display: "flex", 
                            flexDirection: "column", 
                            alignItems: "center" 
                          }}>
                            <Skeleton circle width={20} height={20} />
                            <Skeleton width={25} height={12} style={{ marginTop: '5px' }} />
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>

                  {/* Total PV Row */}
                  <tr>
                    <td>
                      <Skeleton height={24} width={80} style={{ marginBottom: '10px' }} />
                      <Skeleton height={20} width={150} />
                    </td>
                    <td colSpan={4}>
                      <Skeleton height={20} borderRadius={10} />
                      <Skeleton height={16} width={100} style={{ margin: '10px auto 0' }} />
                    </td>
                  </tr>

                  {/* New PV Row */}
                  <tr>
                    <td>
                      <Skeleton height={24} width={70} style={{ marginBottom: '10px' }} />
                      <Skeleton height={20} width={150} />
                    </td>
                    <td colSpan={4}>
                      <Skeleton height={20} borderRadius={10} />
                      <Skeleton height={16} width={100} style={{ margin: '10px auto 0' }} />
                    </td>
                  </tr>

                  {/* New Supervisors Row */}
                  <tr>
                    <td colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                      <Skeleton height={24} width={120} style={{ margin: '0 auto' }} />
                      <Skeleton height={20} width={100} style={{ margin: '10px auto 0' }} />
                      <Skeleton height={16} width={80} style={{ margin: '5px auto 0' }} />
                    </td>
                  </tr>

                </tbody>
              </table>

              {/* Month Tabs */}
              <div className="month-tabs" style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' }}>
                {[...Array(2)].map((_, index) => (
                  <Skeleton 
                    key={index} 
                    width={80} 
                    height={35} 
                    borderRadius={5} 
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncentivesSkeleton;